// src/pages/appointments/AppointmentsLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";

import { useAppointmentsFilters } from "@/pages/appointments/AppointmentsFiltersContext.jsx";
import AppointmentsFilterSheet from "@/pages/appointments/AppointmentsFilterSheet.jsx";

function Sheets() {
  const { isFilterOpen, closeSheet, sheetMode, filters, setFilters, openSheet } =
    useAppointmentsFilters();

  return (
    <>
      {/* Marker ONLY (never blocks clicks) */}
      {isFilterOpen ? (
        <div
          data-bottom-sheet="open"
          style={{ pointerEvents: "none" }}
          className="pointer-events-none"
        />
      ) : null}

      <AppointmentsFilterSheet
        open={isFilterOpen}
        mode={sheetMode}
        value={filters}
        onChange={setFilters}
        onClose={closeSheet}
        onOpenMode={openSheet}
      />
    </>
  );
}

export default function AppointmentsLayout() {
  return (
    <>
      <Outlet />
      <Sheets />
    </>
  );
}